var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.878,
    height: 12.89,
    viewBox: "0 0 13.878 12.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_back_4080892",
    transform: "translate(-1.543 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7810",
    "data-name": "Group 7810",
    transform: "translate(1.543 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5867",
    "data-name": "Path 5867",
    d: "M9.144,3.228a.679.679,0,0,1,0,.9l-.06.06L4.315,8.427H14.743a.678.678,0,0,1,.079,1.352l-.079,0H4.17l4.947,4.948a.679.679,0,0,1,.056.9l-.056.064a.679.679,0,0,1-.9.056l-.064-.056L1.543,9.077,8.186,3.171A.678.678,0,0,1,9.144,3.228Z",
    transform: "translate(-1.543 -3)",
    fill: "#1c75bb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowico);
export default __webpack_public_path__ + "static/media/backArrowico.7b5b96bcc4672be65acbc1d27ef50ecf.svg";
export { ForwardRef as ReactComponent };